_deleteUserProfileImagesThunk